import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { TypedMemo } from '../../../../../common/types';
import { SMLButton } from '../../../../../common/views/SMLButton/SMLButton';
import { useMusic24Capabilities } from '../../../../../music24/hooks/useMusic24Capabilities';
import { useUpgradePrompt } from '../../../../../music24/hooks/useUpgradePrompt';
import { SMLUpgradeFeature } from '../../../../../music24/config/music24PlanCapabilities';
import { songPageMessages } from '../songPageMessages';
import { Panel, PanelBody, PanelHead } from '../../../../../music24/components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song page; each part uses its own slice of it */
import styles from '../SongPage.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * "The times make" (design d1): what the lyric times feed. On Free the full-song videos are gated
 * (design f8 line 1): the master, the lyrics and the sync work on every plan.
 */
const SongTimesMakeCardComponent: React.FC = () => {
  const intl = useIntl();
  const { canRenderFullSongVideos } = useMusic24Capabilities();
  const openUpgrade = useUpgradePrompt();
  const upgrade = useCallback(() => openUpgrade(SMLUpgradeFeature.fullVideo), [openUpgrade]);

  return (
    <div className={styles.stack}>
      <Panel>
        <PanelHead title={intl.formatMessage(songPageMessages.timesMakeTitle)} />
        <PanelBody className={styles.cardBody}>
          <div className={styles.makesList}>
            <span>{intl.formatMessage(songPageMessages.timesMakeLyricVideo)}</span>
            <span>{intl.formatMessage(songPageMessages.timesMakeMoment)}</span>
            <span>{intl.formatMessage(songPageMessages.timesMakeCaptions)}</span>
            <span>{intl.formatMessage(songPageMessages.timesMakeCard)}</span>
          </div>
          <span className={styles.help}>{intl.formatMessage(songPageMessages.timesMakeNote)}</span>
        </PanelBody>
      </Panel>
      {canRenderFullSongVideos === false && (
        <div className={styles.gate} data-testid="song-page-gate-lyric-video">
          <FontAwesomeIcon icon={faLock} />
          <div className={styles.grow}>
            <b>{intl.formatMessage(songPageMessages.timesMakeLyricVideo)}</b>
            <small>{intl.formatMessage(songPageMessages.gateLyricVideo)}</small>
          </div>
          <SMLButton size="sm" color="primary" omitCap onClick={upgrade}>
            {intl.formatMessage(songPageMessages.upgrade)}
          </SMLButton>
        </div>
      )}
    </div>
  );
};

export const SongTimesMakeCard = TypedMemo(SongTimesMakeCardComponent);
